import { BUSINESS_INFO } from './business-info';
import { DefinitionTable, LegalLayout } from './LegalLayout';

/**
 * 特定商取引法に基づく表記。
 *
 * 有料のサービスを提供する以上、決済導線を開ける前にここが埋まっている必要がある。
 * 事業者情報は business-info.ts のプレースホルダを参照している。
 * **法務レビューを通していない下書き**なので、公開前に必ず確認を取ること
 * (docs/deployment.md の「法務ページ」を参照)。
 */
export function CommercePage() {
  return (
    <LegalLayout
      title="特定商取引法に基づく表記"
      lead="特定商取引に関する法律第11条（通信販売についての広告）に基づき、以下のとおり表示します。"
    >
      <DefinitionTable
        rows={[
          { term: '販売事業者', value: BUSINESS_INFO.companyName },
          { term: '運営責任者', value: BUSINESS_INFO.representative },
          {
            term: '所在地',
            value: (
              <>
                {BUSINESS_INFO.address}
                <br />
                <span className="text-ink-subtle">
                  ご請求をいただいた場合には、遅滞なく開示いたします。
                </span>
              </>
            ),
          },
          {
            term: '電話番号',
            value: (
              <>
                {BUSINESS_INFO.phone}
                <br />
                <span className="text-ink-subtle">
                  ご請求をいただいた場合には、遅滞なく開示いたします。お問い合わせは
                  メールにて承っております。
                </span>
              </>
            ),
          },
          { term: 'メールアドレス', value: BUSINESS_INFO.contactEmail },
          {
            term: '販売価格',
            value:
              '各プランの価格は本サービスの料金ページに表示します。表示価格は消費税を含みません。',
          },
          {
            term: '商品代金以外の必要料金',
            value: 'インターネット接続に必要な通信料および決済手数料はお客様のご負担となります。',
          },
          {
            term: '販売数量の単位',
            value:
              'シート単位で販売します。1 シートは利用者 1 名が 1 か月間ご利用いただける権利を指します。',
          },
          {
            term: '支払方法',
            value: 'クレジットカードによる決済（当社が指定する決済代行事業者を通じて行います）。',
          },
          { term: '支払時期', value: '毎月、契約の更新日に当月分をお支払いいただきます。' },
          {
            term: '役務の提供時期',
            value: 'お申し込みおよび決済の完了後、直ちにご利用いただけます。',
          },
          {
            term: '返品・キャンセル',
            value:
              '役務の性質上、提供開始後の返金には応じかねます。次回以降の更新の停止はいつでも管理画面から行っていただけます。停止した場合、当該請求期間の末日まではご利用いただけます。',
          },
          {
            term: '動作環境',
            value:
              '管理画面のご利用には、最新版の Google Chrome、Microsoft Edge、Safari または Firefox が必要です。MCP 接続のご利用には、Model Context Protocol に対応した AI クライアントが必要です。',
          },
        ]}
      />
    </LegalLayout>
  );
}
